<template>
  <div>
    <div>课文回顾</div>
    <div>{{entity.ai_kewen_entity.title}}</div>
    <VideoView :src="entity.ai_kewen_entity.video" style="height: 200px;"></VideoView>

    <div class="pre-wrap">进入消息: {{config.enter_msg}}</div>
    <div class="pre-wrap">需要确认: {{config.enter_ready}}</div>
    <div class="pre-wrap">第一条消息: {{config.first_msg}}</div>
    <div class="pre-wrap">完成模块消息: {{config.finish_msg || '无'}}</div>
    <SttFormat :formats="config.stt_format"/>
  </div>
</template>

<script>
import VideoView from "@/components/VideoView.vue";
import SttFormat from "./stt_format.vue";

export default {
  name: "ai_kewen",
  components: {SttFormat, VideoView},
  props: {
    entity: {
      type: Object,
      default: () => {
        return {}
      }
    },
    config: {
      type: Object,
      default: () => {
        return {}
      }
    },
  }
}
</script>